<template>
  <div>
    <label class="vs-input--label">{{ $t('users.addresses.province') }}</label>
    <v-select
      v-model="province"
      :clearable="false"
      :options="$store.state.config.availableProvinces"
      name="province"
      v-validate="'required'"
      :data-vv-as="$t('users.addresses.province')"
      :dir="$vs.rtl ? 'rtl' : 'ltr'"
    />
    <services-pricing-form :province="province" class="mt-base" v-if="showForm" />
  </div>
</template>

<script>
import ServicesPricingForm from '@/views/pages/admin/config/ServicesPricingForm'
export default {
  name: 'ServicesPricing',
  components: { ServicesPricingForm },
  data() {
    return {
      province: 'default',
      showForm: true
    }
  },
  watch: {
    province() {
      this.showForm = false
      this.$nextTick(() => (this.showForm = this))
    }
  }
}
</script>

<style scoped></style>
